export default __webpack_public_path__ + "static/media/reunion222_w320.a7d393bd.jpg";